import styled from 'styled-components/macro';
import { spin, COLORS } from 'styleguide';

export const LoaderContainer = styled.div`
  position: relative;
  width: 44px;
  height: 44px;
  border-radius: 100%;
  margin: 10px auto;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 100%;
    border: 6px solid ${COLORS.primary};
    border-right-color: transparent;
    animation: ${spin} 2s infinite;
  }
`;

export default LoaderContainer;
